import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Common } from './common';

@Injectable({
  providedIn: 'root'
})
export class CommonService {

  constructor(public httpCliet: HttpClient) { }

  sendMail(map: any): Promise<any> {
    let url: string = Common.url + "contactus/sendmail";
    return this.httpCliet.post<any>(url, map, Common.httpOptions).toPromise();
  }
}
